import { render, staticRenderFns } from "./CodeCard.vue?vue&type=template&id=06ef1e63&"
import script from "./CodeCard.vue?vue&type=script&lang=js&"
export * from "./CodeCard.vue?vue&type=script&lang=js&"
import style0 from "./CodeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports